import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { GroupsPlaceholderComponent } from './groups-placeholder.component';

@NgModule({
  declarations: [GroupsPlaceholderComponent],
  exports: [GroupsPlaceholderComponent],
  imports: [RouterModule, NzButtonModule, NzIconModule],
})
export class GroupsPlaceholderModule { }
